const translations = {
  hindi: {
    welcome: "नमस्ते",
    tagline: "आपकी भाषा, आपका साथी",
    login: "लॉगिन करें",
    register: "रजिस्टर करें",
    name: "नाम",
    mobile: "मोबाइल नंबर",
    password: "पासवर्ड",
    language: "भाषा",
    gender: "लिंग",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    welcomeBack: "स्वागत है",
    greeting: "नमस्ते! मैं हूं स्मार्टसाथी। आपकी भाषा, आपका साथी। किस सेवा के लिए मदद चाहिए?",
    healthSchemes: "स्वास्थ्य योजनाएं",
    educationSupport: "शिक्षा सहायता",
    idServices: "पहचान पत्र सेवाएं",
    financeDBT: "वित्त और DBT",
    learningHub: "डिजिटल लर्निंग हब",
    viewGuide: "चरण-दर-चरण गाइड देखें",
    next: "अगला",
    back: "पीछे",
    submit: "जमा करें",
    startVoice: "आवाज शुरू करें",
    stopVoice: "आवाज बंद करें",
    admin: "एडमिन डैशबोर्ड",
    analytics: "विश्लेषण",
    totalUsers: "कुल उपयोगकर्ता",
    avgTime: "औसत समय",
    mostViewed: "सबसे ज्यादा देखा गया",
    logout: "लॉगआउट",
    footerText: "स्मार्टसाथी — आपकी भाषा, आपका साथी। तकनीक सबके लिए।"
  },
  english: {
    welcome: "Welcome",
    tagline: "Your Language, Your Companion",
    login: "Login",
    register: "Register",
    name: "Name",
    mobile: "Mobile Number",
    password: "Password",
    language: "Language",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    welcomeBack: "Welcome Back",
    greeting: "Namaste! I am SmartSathi. Your Language, Your Companion. Which service can I help you with?",
    healthSchemes: "Health Schemes",
    educationSupport: "Education Support",
    idServices: "ID Services",
    financeDBT: "Finance & DBT",
    learningHub: "Digital Learning Hub",
    viewGuide: "View Step-By-Step Guide",
    next: "Next",
    back: "Back",
    submit: "Submit",
    startVoice: "Start Voice",
    stopVoice: "Stop Voice",
    admin: "Admin Dashboard",
    analytics: "Analytics",
    totalUsers: "Total Users",
    avgTime: "Average Time",
    mostViewed: "Most Viewed",
    logout: "Logout",
    footerText: "SmartSathi — Your Language, Your Companion. Technology for everyone."
  },
  marathi: {
    welcome: "स्वागत आहे",
    tagline: "तुमची भाषा, तुमचा साथी",
    login: "लॉगिन करा",
    register: "नोंदणी करा",
    name: "नाव",
    mobile: "मोबाइल नंबर",
    password: "पासवर्ड",
    language: "भाषा",
    gender: "लिंग",
    male: "पुरुष",
    female: "स्त्री",
    other: "इतर",
    welcomeBack: "परत स्वागत आहे",
    greeting: "नमस्कार! मी आहे स्मार्टसाथी। तुमची भाषा, तुमचा साथी। कोणत्या सेवेसाठी मदत हवी आहे?",
    healthSchemes: "आरोग्य योजना",
    educationSupport: "शिक्षण सहाय्य",
    idServices: "ओळखपत्र सेवा",
    financeDBT: "वित्त आणि DBT",
    learningHub: "डिजिटल लर्निंग हब",
    viewGuide: "पायरी-दर-पायरी मार्गदर्शक पहा",
    next: "पुढे",
    back: "मागे",
    submit: "सबमिट करा",
    startVoice: "आवाज सुरू करा",
    stopVoice: "आवाज थांबवा",
    admin: "प्रशासक डॅशबोर्ड",
    analytics: "विश्लेषण",
    totalUsers: "एकूण वापरकर्ते",
    avgTime: "सरासरी वेळ",
    mostViewed: "सर्वाधिक पाहिलेले",
    logout: "लॉगआउट",
    footerText: "स्मार्टसाथी — तुमची भाषा, तुमचा साथी। तंत्रज्ञान सर्वांसाठी."
  },
  tamil: {
    welcome: "வரவேற்கிறோம்",
    tagline: "உங்கள் மொழி, உங்கள் தோழன்",
    login: "உள்நுழைய",
    register: "பதிவு செய்ய",
    name: "பெயர்",
    mobile: "மொபைல் எண்",
    password: "கடவுச்சொல்",
    language: "மொழி",
    gender: "பாலினம்",
    male: "ஆண்",
    female: "பெண்",
    other: "மற்றவை",
    welcomeBack: "மீண்டும் வரவேற்கிறோம்",
    greeting: "வணக்கம்! நான் ஸ்மார்ட்சாத்தி. உங்கள் மொழி, உங்கள் தோழன். எந்த சேவைக்கு உதவி தேவை?",
    healthSchemes: "சுகாதார திட்டங்கள்",
    educationSupport: "கல்வி ஆதரவு",
    idServices: "அடையாள சேவைகள்",
    financeDBT: "நிதி மற்றும் DBT",
    learningHub: "டிஜிட்டல் கற்றல் மையம்",
    viewGuide: "படிப்படியான வழிகாட்டியைப் பார்க்க",
    next: "அடுத்து",
    back: "பின்",
    submit: "சமர்ப்பிக்கவும்",
    startVoice: "குரல் தொடங்கு",
    stopVoice: "குரல் நிறுத்து",
    admin: "நிர்வாக டாஷ்போர்டு",
    analytics: "பகுப்பாய்வு",
    totalUsers: "மொத்த பயனர்கள்",
    avgTime: "சராசரி நேரம்",
    mostViewed: "அதிகம் பார்க்கப்பட்டது",
    logout: "வெளியேறு",
    footerText: "ஸ்மார்ட்சாத்தி — உங்கள் மொழி, உங்கள் தோழன். அனைவருக்கும் தொழில்நுட்பம்."
  }
};

export default translations;